import { Box } from "@chakra-ui/react"
import { isBlocksStep } from "@pathwright/blocks-engine/src/utils/utils"
import { flattenEdges } from "@pathwright/utils"
import {
  createPathFromItems,
  getPathStepById,
  getPathStepBySourceId
} from "../../path/utils"
import { CoverPagePathItemFragment as CoverPagePreviewPathItem } from "@pathwright/graphql-client/src/generated"
import { useCoverPageContext } from "../CoverPageProvider"
import { PreviewPathDotNav } from "./PathPreviewNavigator"
import { PreviewPathCard } from "./PreviewPathCard"
import { PreviewStepCard } from "./PreviewStepCard"

export const CoverPagePreviewImmersive = ({ id }: { id?: number | "path" }) => {
  const resource = useCoverPageContext((v) => v.resource)
  const previewNavItems = useCoverPageContext((v) => v.previewNavItems)
  const hasPreviewSteps = previewNavItems?.length > 1

  const path = resource?.preview_group?.path

  if (!previewNavItems?.length) return null
  if (!path) return null

  if (!id) id = "path"

  const flattenedPathItems = flattenEdges(
    path?.items || []
  ) as CoverPagePreviewPathItem[]
  const pathItems = createPathFromItems(flattenedPathItems)

  let content: React.ReactNode = null

  if (id === "path") {
    content = <PreviewPathCard data={pathItems} isImmersive />
  } else {
    const step =
      getPathStepBySourceId(pathItems, Number(id)) ||
      getPathStepById(pathItems, Number(id))

    if (step && isBlocksStep(step)) {
      content = <PreviewStepCard data={step} isImmersive />
    }
  }

  if (content) {
    return (
      <Box
        className="CoverPagePreviewImmersive"
        w="100%"
        h="100%"
        pos="relative"
        p={0}
        maxW="1000px"
        mx="auto"
        css={{
          base: {},
          md: {
            "& .PathPreviewNavigator": {
              position: "fixed",
              // 7px modal offset from top; 20px top padding; 30px half header height; 13px half dot nav height
              top: "calc(7px + 20px + 30px - 13px)",
              zIndex: "1",
              left: "50%",
              transform: "translateX(-50%)"
            }
          }
        }}
      >
        {hasPreviewSteps && <PreviewPathDotNav />}
        {content}
      </Box>
    )
  }

  return null
}
